import React from "react";
import {TextInput} from "../../../components";
import FormField from "../../../components/form/FormField";
import SignatureInput from "../../../components/signature-input/SignatureInput";
import NabidhFormTextEnum from "../NabidhFormTextEnum";
import DateUtil from "../../../utils/DateUtil";
import moment from "moment";

const getLocalizedText = (key, selectedLanguage) => {
    return NabidhFormTextEnum[key] ? NabidhFormTextEnum[key][selectedLanguage] : '';
};

const PatientInformation = ({selectedLanguage, patientName, mrnNo, patientDOB}) => {
    return (
        <div style={{border: "1px solid #000000"}}>
            <div style={{margin: "15px 15px"}}>
                <h5>{getLocalizedText('Patient_Information', selectedLanguage)}</h5>
                <div className="row" style={{marginTop: "10px", marginLeft: "0px"}}>
                    <div className="col-md-5">
                        <b>{getLocalizedText('Name', selectedLanguage)}</b> {patientName}
                    </div>
                    <div className="col-md-4">
                        <b>{getLocalizedText('MRN', selectedLanguage)}</b> {mrnNo}
                    </div>
                    <div className="col-md-3">
                        <b>{getLocalizedText('DOB', selectedLanguage)}</b> {DateUtil.formatDate(patientDOB)}
                    </div>
                </div>
            </div>
        </div>
    );
};

const NabidhInformation = ({selectedLanguage}) => {
    const isArabic = selectedLanguage === 'Arabic';
    const textDirection = isArabic ? 'rtl' : 'ltr';
    const textAlign = isArabic ? 'right' : 'left';

    return (
        <>
            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit', fontWeight: 'bold'}}>
                        {getLocalizedText('Consent_Acknowledgment_Header', selectedLanguage)}
                    </p>
                </div>
            </div>
            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                        {getLocalizedText('Consent_Statement_1', selectedLanguage)}
                    </p>
                </div>
            </div>
            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                        {getLocalizedText('Consent_Statement_2', selectedLanguage)}
                    </p>
                </div>
            </div>
            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                        {getLocalizedText('Consent_Statement_3', selectedLanguage)}
                    </p>
                </div>
            </div>
            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                        {getLocalizedText('Consent_Statement_4', selectedLanguage)}
                    </p>
                </div>
            </div>
            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                        {getLocalizedText('Consent_Statement_5', selectedLanguage)}
                    </p>
                </div>
            </div>
            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                        {getLocalizedText('Consent_Statement_6', selectedLanguage)}
                    </p>
                </div>
            </div>

            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                        {getLocalizedText('Consent_Statement_7', selectedLanguage)}
                    </p>
                </div>
            </div>
        </>
    );
};

const PatientSignatureSection = ({
    selectedLanguage,
    readOnly,
    consentDate,
    patientName,
    patientSignature,
    onSavePatientSignature,
    pushFormFieldRef
}) => {
    return (
        <div className="container">
            <div className="row" style={{marginTop: "10px"}}>
                <div className="col-md-3 dim14-form-label">
                    {getLocalizedText('Date', selectedLanguage)}
                </div>
                <div className="col-md-3">
                    {moment(consentDate).format('MMMM DD, YYYY')}
                </div>
            </div>

            <div className="row" style={{marginTop: "15px"}}>
                <div className="col-md-3 dim14-form-label">
                    {getLocalizedText('Patient_Name', selectedLanguage)}
                </div>
                <div className="col-md-9">
                    {patientName}
                </div>
            </div>

            <div className="row" style={{marginTop: "15px"}}>
                <div className="col-md-6 dim14-form-label">
                    {getLocalizedText('Patient_Signature', selectedLanguage)}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <FormField ref={formField => pushFormFieldRef(formField)}
                               disabled={readOnly}
                               validateOn={patientSignature}>
                        <SignatureInput
                            signature={patientSignature}
                            onSave={onSavePatientSignature}
                            readOnly={readOnly}/>
                    </FormField>
                </div>
            </div>
        </div>
    );
};

const WitnessSection = ({
    selectedLanguage,
    readOnly,
    witnessName,
    witnessSignature,
    relationshipToPatient,
    onWitnessNameChange,
    onRelationshipChange,
    onSaveWitnessSignature
}) => {
    const isArabic = selectedLanguage === 'Arabic';
    const textDirection = isArabic ? 'rtl' : 'ltr';
    const textAlign = isArabic ? 'right' : 'left';

    return (
        <>
            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                    <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                        {getLocalizedText('Guardian_Section_Header', selectedLanguage)}
                    </p>
                </div>
            </div>

            <div className="container">
                <div className="row" style={{marginTop: "15px"}}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Parent_Guardian_Name', selectedLanguage)}
                    </div>
                    <div className="col-md-9 dim14-base-input">
                        <TextInput value={witnessName}
                                   disabled={readOnly}
                                   alphabeticOnly
                                   style={{textAlign: "center"}}
                                   onChange={onWitnessNameChange}/>
                    </div>
                </div>

                <div className="row" style={{marginTop: "15px"}}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Guardian_Relationship', selectedLanguage)}
                    </div>
                    <div className="col-md-9 dim14-base-input">
                        <TextInput value={relationshipToPatient}
                                   disabled={readOnly}
                                   alphabeticOnly
                                   style={{textAlign: "center"}}
                                   onChange={onRelationshipChange}/>
                    </div>
                </div>

                <div className="row" style={{marginTop: "15px"}}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Witness_Signature', selectedLanguage)}
                    </div>
                    <div className="col-md-9">
                        <SignatureInput
                            signature={witnessSignature}
                            onSave={onSaveWitnessSignature}
                            readOnly={readOnly}/>
                    </div>
                </div>
            </div>
        </>
    );
};

const NabidhConsentFormParts = {
    PatientInformation,
    NabidhInformation,
    PatientSignatureSection,
    WitnessSection
};

export default NabidhConsentFormParts;

